import {
  CourseLine,
  CourseLineCategory,
  CourseLineSubCategory,
} from '@/models/CourseLine';

export function courseLineGenerator(
  courseLine?: Partial<CourseLine>,
): CourseLine {
  return {
    id: 1,
    name: 'Linha de Curso',
    category: CourseLineCategory.TECHNOLOGY,
    subcategory: CourseLineSubCategory.CTRL_PLAY,
    ...courseLine,
  };
}
